import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { useIsEditorReadonly } from '@/hooks/use-is-editor-readonly';
import { type ReactNodeViewProps, NodeViewContent } from '@tiptap/react';
import { PlusIcon } from 'lucide-react';
import { memo } from 'react';

const ADD_PAIR_CLASS =
    'group flex w-full items-center justify-center gap-2 rounded-lg border-2 border-gray-300 px-4 py-1 text-gray-500 transition-all duration-200 hover:border-blue-400 hover:bg-blue-50 hover:text-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none dark:border-gray-600 dark:text-gray-400 dark:hover:border-blue-500 dark:hover:bg-blue-950/20 dark:hover:text-blue-400 dark:focus:ring-offset-gray-900';

const MatchingNodeView: React.FC<ReactNodeViewProps> = ({ node, selected, editor, getPos, decorations }) => {
    const isEditorReadonly = useIsEditorReadonly(editor);
    const addPair = () => {
        const pos = getPos();
        if (typeof pos !== 'number') {
            return;
        }

        const newPos = pos + node.nodeSize - 1;

        editor
            .chain()
            .focus()
            .insertContentAt(newPos, {
                type: 'matchingPair',
                content: [
                    {
                        type: 'matchingPairTerm',
                        content: [
                            {
                                type: 'paragraph',
                            },
                        ],
                    },
                    {
                        type: 'matchingPairDefinition',
                        content: [
                            {
                                type: 'paragraph',
                            },
                        ],
                    },
                    {
                        type: 'matchingPairExplanation',
                        content: [
                            {
                                type: 'paragraph',
                            },
                        ],
                    },
                ],
            })
            .setTextSelection(newPos + 1)
            .run();
    };

    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label="Matching Pairs"
            selected={selected}
            containerClassName="rounded-lg border-2 border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-900/50"
            contentClassName="pt-6 px-1"
        >
            <div className="flex gap-1">
                <div className="w-full  pl-4 pr-4">
                    <NodeViewContent />
                    <div
                        className="mb-2 flex gap-2 justify-end"
                        contentEditable={false}
                    >
                        <button
                            onClick={addPair}
                            className={ADD_PAIR_CLASS}
                            disabled={isEditorReadonly}
                        >
                            <PlusIcon className="h-4 w-4" />
                            <span className="text-sm font-medium">Add Pair</span>
                        </button>
                    </div>
                </div>
            </div>
        </CommonNodeViewWrapper>
    );
};

export default memo(MatchingNodeView);
